/*
  Open the Motion cart drawer instead of visiting /cart.
  Add to theme.liquid before </body>:
  <script src="{{ 'carakit-cart-drawer-nav.js' | asset_url }}" defer></script>
*/
(function () {
  function isCartPath(href) {
    if (!href) return false;
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      var path = url.pathname.replace(/\/+$/, '') || '/';
      return path === '/cart';
    } catch (e) {
      return href === '/cart' || href === '/cart/';
    }
  }

  function openDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.add('drawer--is-open');
      document.documentElement.classList.add('js-drawer-open');
    }

    var safe = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
    if (safe && !isCartPath(safe.getAttribute('href') || '')) {
      try { safe.click(); } catch (e) {}
    }
  }

  window.CaraKitOpenCartDrawer = openDrawer;

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    if (!isCartPath(link.getAttribute('href'))) return;
    event.preventDefault();
    event.stopPropagation();
    openDrawer();
  }, true);

  if (isCartPath(window.location.href)) {
    try { sessionStorage.setItem('ckOpenDrawer', '1'); } catch (e) {}
    var back = document.referrer;
    if (back && back.indexOf(window.location.host) !== -1 && !isCartPath(back)) {
      window.location.replace(back);
    } else {
      window.location.replace('/');
    }
    return;
  }

  try {
    if (sessionStorage.getItem('ckOpenDrawer')) {
      sessionStorage.removeItem('ckOpenDrawer');
      var start = function () { setTimeout(openDrawer, 250); };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }
    }
  } catch (e) {}
})();
